<template>
  <div class="xm-preview-image" :style="{ width: width, height: height }">
    <!-- 展示小图 -->
    <div
      ref="small-image"
      class="small-image-container"
      :style="{ width: width, height: height }"
      @mouseover="handleHoverSmallImage"
      @mouseleave="handleMouseLeaveSmallImage"
    >
      <img @error="handleImgError" :src="imgSrc | httpImgUrl" />
    </div>
    <!-- 预览大图 -->
    <div ref="big-image" class="big-image-container">
      <img @error="handleImgError" :src="imgSrc | httpImgUrl" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'XmHoverPreviewImage',
  props: {
    width: {
      // 小图的宽度
      type: String,
      default: '100px',
    },
    height: {
      // 小图的高度
      type: String,
      default: '100px',
    },
    imgSrc: {
      // 图片地址
      type: String,
      default: '',
    },
  },
  data() {
    return {
      smallImgDom: null, // 小图的 Dom 元素
      bigImgDom: null,

      bigImgWidth: '230px', // 预览大图的宽度
      bigImgHeight: '230px', // 预览大图的高度
      margin: 5, // 预览大图与小图的间距

      transformOrigin: 'top left', // 动画效果的改变原点
      animation: null,
    };
  },
  filters: {
    httpImgUrl(val) {
      if (val.substring(0, 5) == 'blob:') {
        return val;
      }
      if (val.substring(0, 6) == 'https:') {
        return 'https://img.ximu.cn/' + val.split('/').pop();
      }
      if (val.substring(0, 5) !== 'blob:' && val.substring(0, 6) !== 'https:') {
        return 'https://img.ximu.cn/' + val.split('/').pop();
      }
    },
  },
  methods: {
    // 获取图片尺寸
    getImgSize(url) {
      return new Promise((resolve, reject) => {
        let imgObj = new Image();
        imgObj.src = url;
        imgObj.onload = () => {
          resolve({
            width: imgObj.width,
            height: imgObj.height,
          });
        };
        imgObj.onerror = () => {
          reject(`${imgObj} loading failed. `);
        };
      });
    },
    // 根据当前屏幕顶部和底部的剩余上下高度，改变预览大图的位置
    handleUpdateBigImgPosition() {
      if (!this.smallImgDom) {
        return;
      }
      const { top, left, bottom } = this.smallImgDom.getBoundingClientRect();
      // 预览大图应当在下边还是上边
      const isAtBottom = window.innerHeight - bottom >= 230 || top < 230;

      this.transformOrigin = isAtBottom ? 'top left' : 'bottom left';
      if (this.bigImgDom) {
        /**
         * 动态改变预览大图的位置
         */
        // y 轴偏移量
        const offset = isAtBottom
          ? parseInt(this.width) + this.margin
          : -1 * (parseInt(this.bigImgWidth) + this.margin);
        const yPos = top + offset + 'px';
        const xPos = left + 'px';

        this.bigImgDom.style.top = yPos;
        this.bigImgDom.style.left = xPos;
        this.bigImgDom.style.transformOrigin = this.transformOrigin;
      }
    },
    /**
     * 鼠标悬浮小图，展示预览大图
     */
    handleHoverSmallImage() {
      if (this.bigImgDom) {
        this.animation.play();
        this.bigImgDom.style.display = 'block';
        this.handleUpdateBigImgPosition();
      }
    },
    /**
     * 鼠标离开小图，预览大图消失
     */
    handleMouseLeaveSmallImage() {
      if (this.bigImgDom) {
        this.bigImgDom.style.display = 'none';
      }
    },
    /**
     * 将预览大图元素插入vue根元素
     * 防止预览大图被其他元素遮住
     */
    handleAppendToRoot() {
      const body = document.querySelector('#app');

      if (this.bigImgDom) {
        /**
         * appendChild 后，所有的 style 样式都会失效，原因不明
         * 需要像下面这样手动设置
         */
        this.bigImgDom.style.width = this.bigImgWidth;
        this.bigImgDom.style.height = this.bigImgHeight;
        this.bigImgDom.children[0].style.objectFit = 'contain';
        this.bigImgDom.children[0].style.width = '230px';
        // this.bigImgDom.children[0].style.width = this.bigImgWidth;
        this.bigImgDom.children[0].style.height = this.bigImgHeight;
        this.bigImgDom.style.transformOrigin = this.transformOrigin;
        this.bigImgDom.style.backgroundColor = '#f7f7f7';
        this.bigImgDom.style.position = 'fixed';
        this.bigImgDom.style.zIndex = '3000';
        this.bigImgDom.style.top = '0';
        this.bigImgDom.style.left = '0';
        this.bigImgDom.style.display = 'none';

        /**
         * 添加动画
         */
        const keyframes = [{ scale: 0 }, { scale: 1 }];
        const options = {
          duration: 100,
        };
        this.animation = this.bigImgDom.animate(keyframes, options);

        body.appendChild(this.bigImgDom);
      }
    },
  },
  async mounted() {
    // try {
    // let imgSize = await this.getImgSize(this.imgSrc);

    this.$nextTick(() => {
      this.smallImgDom = this.$refs['small-image'];
      this.bigImgDom = this.$refs['big-image'];

      // if (imgSize.width > imgSize.height) {
      //   this.bigImgWidth = 'auto';
      // } else {
      //   this.bigImgHeight = 'auto';
      // }

      this.handleAppendToRoot(); // 预览大图元素插入根元素
      this.handleUpdateBigImgPosition();
    });
    /**
     * 绑定监听函数，监听窗口滚动和缩放，实时检查屏幕剩余高度，调整预览大图位置
     * 优化：节流函数
     */
    // 绑定滚动监听
    window.addEventListener(
      'scroll',
      this.throttle(this.handleUpdateBigImgPosition, 500)
    );
    // 窗口缩放监听
    window.addEventListener(
      'resize',
      this.throttle(this.handleUpdateBigImgPosition, 500)
    );
    // } catch (err) {
    //   this.$message.error(err);
    // }
  },
  beforeDestroy() {
    // 离开销毁dom
    const body = document.querySelector('#app');
    if (this.bigImgDom) {
      body.removeChild(this.bigImgDom);
    }
  },
};
</script>
<style lang="scss" scoped>
.xm-preview-image {
  width: 100px;
  height: 100px;
  position: relative;

  .small-image-container {
    & > img {
      width: 100%;
      height: 100%;

      object-fit: cover;
    }
  }

  .big-image-container {
    width: 230px;
    height: 230px;

    object-fit: contain;

    display: none;
    overflow: hidden;
    position: relative;

    background-color: #fff;

    img {
      object-fit: cover;
    }
  }
}
</style>
